<style>
  .alert{
  transition-duration:1s; /* <= creates fade out effect */
  transition-delay:1s;
}
</style>

<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true">
            Loading your data ...
        </div>

        <div v-if="loading == false && (makeup_area == '' || makeup_area == null)" >
            
            <p>Where are you working today ?</p><br />
            <div class="notification is-warning" v-if="operations.length == 0">
              Loading operations ...
            </div>
            <button class="button is-large is-fullwidth  mb-4" :class="{'is-primary' : row.printing == 1, 'is-info' : row.makeup == 1}" :disabled="loading==true" @click="updateArea(row.name)" v-for="row in operations" :key="row.id">{{ row.label }}</button>
            
            
        </div>

        <div v-if="loading == false && (makeup_input_location_id == '' || makeup_input_location_id == null || makeup_input_location_id == 0)" >
            
            <p>Where are you located ?</p><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" @click="updateLocation(1)">Strabane</button><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" @click="updateLocation(3)">Dublin</button><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" @click="updateLocation(4)">Derry</button><br />
        </div>
        
        <div v-if="loading == false && (makeup_area != '' && makeup_input_location_id != '' )" >
            <h2 class="title is-5">{{ selectedMakeupArea }} - {{ selectedLocation }}<br />
              &nbsp;{{ user.firstname }} {{ user.surname }}.</h2>
            <form @submit.prevent="processBundle()" autocomplete="off">
                <input class="input is-large" type="text" placeholder="Enter bundle code here" v-model="bundle_code" ref="makeup_data_input" autocomplete="off"><br /><br />
                <button class="button is-large is-fullwidth is-info" :disabled="loading==true" >Process</button>
                
            </form>

            <br /><br />

            <h2 class="title">Recent Actions Log</h2>
            <span v-for="(row, index) in actions_log" :key="index" :class="{'has-text-danger':row.error === true, 'has-text-success':row.success === true}">{{ row.label}}<br /></span>

            <br /><br />
            <button class="button is-large is-fullwidth is-warning" :disabled="loading==true" @click="updateArea('')">Change Operation</button>
            <br />
            <button class="button is-large is-fullwidth is-link" :disabled="loading==true" @click="updateLocation('')">Change Location</button>
            
        </div>
        
    </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'DataInputMakeup',
  mixins: [OrderMixin],
  data() {
    
    return {
      order: {orderID: 0},
      makeup_area: '',
      loading: false,
      bundle_code: '',
      access_token: '',
      processed:false,
      actions_log : [],
      makeup_input_location_id: '',
      operations: '',
      user: [],
      
    }
  },
   methods: {
    
      async processBundle()
      {
          this.working = true

         
            
            var formdata = { 
                bundle_code: this.bundle_code,
                area : this.makeup_area,
                location_id : this.makeup_input_location_id
            }; 

            OrderService.bundleInputData(this.accessToken, formdata, this.area)
            .then((response) => {
                //this.getOrder()
                console.log(response)
                
                this.actions_log.unshift({label : "Bundle " + this.bundle_code + " processed", error: false})

                if(response.area_complete == 1)
                {
                  this.actions_log.unshift({label : "All bundles now processed for that area", error: false, success: true})
                }

                this.bundle_code = ''
                this.focusInput()

                this.working = false
            }).catch((error) => {
              if(error.response.status == 409)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " already processed", error : true})
              }
              if(error.response.status == 428)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " cannot be processed at this operation until earlier operations are completed", error : true})
              }
              else if(error.response.status == 400)
              {
                this.actions_log.unshift({label : "Error - " + this.bundle_code + " not valid", error : true})
              }
              else {
                alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
              }
              this.bundle_code = ''
                this.focusInput()
                
                this.working = false
            });
            
            
           
            
           
      },
      updateArea(value) {
        this.loading=true
        this.makeup_area = value
        this.loading = false;

        if(this.makeup_area != '')
        {
            
            this.focusInput()
        }
        
      },
      updateLocation(value) {
        this.loading=true
        this.makeup_input_location_id = value
        this.loading = false;

        if(this.makeup_input_location_id != '')
        {
            this.focusInput()
        }
        
      },
      focusInput() {
          this.$nextTick(() => this.$refs.makeup_data_input.focus())
      }
     
   },
   mounted() {
       if (localStorage.makeup_area) {
      this.makeup_area = localStorage.makeup_area;
    }
    else{
      this.makeup_area = ''
    }

    if (localStorage.makeup_input_location_id) {
      this.makeup_input_location_id = localStorage.makeup_input_location_id;
    }
    else{
      this.makeup_input_location_id = ''
    }

    this.focusInput();
    
  },
  computed : {
      
  },
  watch: {
    makeup_area: function () {
     localStorage.makeup_area = this.makeup_area;
      
    },

    makeup_input_location_id: function () {
     localStorage.makeup_input_location_id = this.makeup_input_location_id;
      
    },
    
    
  },
  created() {
     this.getAccessToken()
        .then(() => { 
          this.getUserProfile();
          this.getOperations();
        });

        
  },
}
</script>